import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=2db792a7&scoped=true"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=2db792a7&prod&scoped=true&lang=css"
import style1 from "./CustomersTable.vue?vue&type=style&index=1&id=2db792a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db792a7",
  null
  
)

export default component.exports